import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 80px;
`;

export const Nav = styled.nav`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 20px;
`;

export const IconButton = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
`;

export const NavbarTitle = styled.h1`
`;
